import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mount", "error"]
  static values = {
    publishableKey: String,
    clientSecret: String
  }

  connect() {
    this.checkout = null
    this.mount()
  }

  disconnect() {
    if (this.checkout && typeof this.checkout.destroy === "function") {
      this.checkout.destroy()
    }
  }

  async mount() {
    if (!this.hasMountTarget) return

    try {
      await this.loadStripeScript()

      if (!window.Stripe) {
        throw new Error("Stripe.js was not loaded.")
      }

      const stripe = window.Stripe(this.publishableKeyValue)
      this.checkout = await stripe.initEmbeddedCheckout({
        clientSecret: this.clientSecretValue
      })
      this.checkout.mount(this.mountTarget)
    } catch (error) {
      this.showError()
      // Avoid leaking Stripe internals to customers, but keep enough detail in dev tools.
      console.warn("[stripe] embedded checkout mount failed", error)
    }
  }

  loadStripeScript() {
    if (window.Stripe) return Promise.resolve()

    const existingScript = document.querySelector("script[data-stripe-js]")
    if (existingScript) {
      return new Promise((resolve, reject) => {
        existingScript.addEventListener("load", resolve, { once: true })
        existingScript.addEventListener("error", reject, { once: true })
      })
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://js.stripe.com/v3/"
      script.async = true
      script.dataset.stripeJs = "true"
      script.addEventListener("load", resolve, { once: true })
      script.addEventListener("error", reject, { once: true })
      document.head.appendChild(script)
    })
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.hidden = false
    }
  }
}
